// extracted by mini-css-extract-plugin
module.exports = {"media-kit":"Index_media-kit_2PBJE","dark":"Index_dark_1YNIO"};